module.exports = __webpack_public_path__ + "img/cloud-fog-moon.451b4bf5.svg";